import { isSuccess, Result } from '@carvana/merch-result';
import { httpWithAuth } from '~/clients';
import { getTrades } from '~/constants/endpoints';
import AcquisitionSummary from '~/contracts/common/Trade';
import { MerchUiTradeResponse } from '~/pages/api/trades/v1/get';

export default async function fetchAcquisitionSummaries(
  correlationId: string
): Promise<AcquisitionSummary[]> {
  const url = getTrades({ currentPageUrl: window.location.href });

  const { data } = await httpWithAuth.get<Result<MerchUiTradeResponse>>(url, {
    headers: {
      'x-client-id': '40b6459c-f085-455f-ae19-d8070cbf9f5c',
      'x-correlation-id': correlationId
    }
  });

  return isSuccess(data) ? data.content.trades : [];
}
